import AssignmentIcon from '@mui/icons-material/Assignment';
import DraftsIcon from '@mui/icons-material/Drafts';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PersonIcon from '@mui/icons-material/Person';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

import { DashboardGrid, DashboardCard, DashboardLink, CardTitle } from './common';

const OwnerDashboard = () => {
  return (
    <DashboardGrid>
      <DashboardCard>
        <DashboardLink href="/jobs/new">
          <AssignmentIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Create a Job</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/pending">
          <PendingActionsIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Pending Jobs</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/completed">
          <AssignmentTurnedInIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Completed Jobs</CardTitle>
        </DashboardLink>
      </DashboardCard>
      {/* <DashboardCard>
        <DashboardLink href="/jobs/draft">
          <DraftsIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Draft Jobs</CardTitle>
        </DashboardLink>
      </DashboardCard> */}
      <DashboardCard>
        <DashboardLink href="/account/profile">
          <PersonIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Profile</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/approvals">
          <ThumbUpAltIcon fontSize="large" sx={{ mb: 1 }}  className={"rounded-icon"}/>
          <CardTitle>Job Approvals</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/completion">
          <CheckCircleIcon fontSize="large" sx={{ mb: 1 }}  className={"rounded-icon"}/>
          <CardTitle>Completion Approval</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/account/funds">
          <AccountBalanceWalletIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Account Funds</CardTitle>
        </DashboardLink>
      </DashboardCard>
    </DashboardGrid>
  );
};

export default OwnerDashboard;
